module.exports = __webpack_public_path__ + "img/1.b7a9c431.jpg";